export var networkNoticeChatHandlerMap = new Map();



//////////////////
// WEBPACK FOOTER
// ./src/features/network/networkNoticeChatHandlerMap.ts
// module id = 2007
// module chunks = 3